var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#758F9D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6448 26.9958C8.30053 26.8396 8.20574 26.5646 8.21303 26.1948C8.28074 22.6042 11.0203 19.4141 14.55 18.8302C15.0053 18.7546 15.4661 18.7173 15.9276 18.7188C16.7089 18.7188 17.4901 18.6964 18.2682 18.725C21.2823 18.837 23.4875 20.2667 24.9281 22.8917C25.4938 23.9214 25.7385 25.0448 25.788 26.2172C25.8037 26.5818 25.6896 26.8422 25.3563 26.9984L8.6448 26.9958Z",
    fill: "#DCEEF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5083 7.00363C17.8031 7.08905 18.1109 7.11249 18.4078 7.19374C20.8557 7.86353 22.5057 10.2609 22.2437 12.7818C21.989 15.2297 20.1432 17.1568 17.7203 17.4989C14.7917 17.9156 12.0505 15.7614 11.7609 12.8203C11.6171 11.4442 12.0204 10.0668 12.8838 8.98561C13.7471 7.90445 15.0012 7.20636 16.375 7.04217C16.4057 7.03853 16.4417 7.04634 16.4526 7.00363H17.5083Z",
    fill: "#DCEEF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.d442a7b5933400e928d14a0e0a7f0c52.svg";
export { ForwardRef as ReactComponent };